var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2955 20L18.5 16.8027V23.1972L23.2955 20ZM25.532 20.312L17.5828 25.6115C17.5263 25.6491 17.4607 25.6706 17.3929 25.6739C17.3252 25.6771 17.2578 25.6619 17.198 25.6299C17.1382 25.5979 17.0882 25.5502 17.0533 25.4921C17.0185 25.4339 17 25.3673 17 25.2995V14.7005C17 14.6327 17.0185 14.5661 17.0533 14.5079C17.0882 14.4497 17.1382 14.4021 17.198 14.3701C17.2578 14.3381 17.3252 14.3229 17.3929 14.3261C17.4607 14.3294 17.5263 14.3509 17.5828 14.3885L25.532 19.688C25.5834 19.7222 25.6255 19.7686 25.6546 19.8231C25.6837 19.8775 25.699 19.9383 25.699 20C25.699 20.0617 25.6837 20.1225 25.6546 20.1769C25.6255 20.2313 25.5834 20.2777 25.532 20.312Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon2.8cc94144534b0dec9fe0a21b6738ab34.svg";
export { ForwardRef as ReactComponent };